/* ════════════════════════════════════════════════════════════
   "HUMAN ERROR"™ — theme.js
   ════════════════════════════════════════════════════════════ */

(function(){
  'use strict';

  /* ──────── Notification ──────── */
  function notify(msg){
    var n = document.getElementById('he-notification');
    if(!n){
      n = document.createElement('div');
      n.id = 'he-notification';
      n.className = 'notification';
      document.body.appendChild(n);
    }
    n.textContent = msg;
    n.classList.add('show');
    clearTimeout(n._t);
    n._t = setTimeout(function(){ n.classList.remove('show'); }, 3000);
  }
  window.HEnotify = notify;

  /* ──────── Smooth scroll for in-page anchors ──────── */
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var href = a.getAttribute('href');
    if(href && href.length > 1 && document.querySelector(href)){
      e.preventDefault();
      document.querySelector(href).scrollIntoView({behavior:'smooth', block:'start'});
    }
  });

  /* ──────── Glitch-shake on product card click ──────── */
  document.addEventListener('click', function(e){
    var card = e.target.closest('.card');
    if(!card) return;
    card.style.transition = 'transform 0.08s';
    var n = 0;
    var id = setInterval(function(){
      card.style.transform = 'translate(' + ((Math.random()-0.5)*6) + 'px,' + ((Math.random()-0.5)*6) + 'px)';
      if(++n > 4){ clearInterval(id); card.style.transform = ''; }
    }, 40);
  });

  /* ──────── Countdown ──────── */
  function initCountdown(el){
    var iso = el.dataset.target;
    if(!iso) return;
    var target = new Date(iso);
    var nums = el.querySelectorAll('.num');
    function tick(){
      var diff = target - new Date();
      var d = Math.max(0, Math.floor(diff/86400000));
      var h = Math.max(0, Math.floor((diff%86400000)/3600000));
      var m = Math.max(0, Math.floor((diff%3600000)/60000));
      var s = Math.max(0, Math.floor((diff%60000)/1000));
      if(nums[0]) nums[0].textContent = String(d).padStart(2,'0');
      if(nums[1]) nums[1].textContent = String(h).padStart(2,'0');
      if(nums[2]) nums[2].textContent = String(m).padStart(2,'0');
      if(nums[3]) nums[3].textContent = String(s).padStart(2,'0');
    }
    tick();
    setInterval(tick, 1000);
  }
  document.querySelectorAll('.countdown[data-target]').forEach(initCountdown);

  /* ──────── Product gallery thumb switcher ──────── */
  document.querySelectorAll('.product-gallery').forEach(function(g){
    var main = g.querySelector('.main-image img');
    g.querySelectorAll('.thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        if(!main) return;
        var src = b.dataset.full || b.querySelector('img').src;
        main.src = src;
        g.querySelectorAll('.thumbs button').forEach(function(x){ x.classList.remove('active'); });
        b.classList.add('active');
      });
    });
  });

  /* ──────── Update cart count in header ──────── */
  function updateCartCount(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = String(cart.item_count).padStart(2, '0');
        });
      })
      .catch(function(){});
  }
  window.HEupdateCart = updateCartCount;

  /* ──────── Ajax add to cart on PDP ──────── */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form.matches('form[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('.add-to-cart');
    var orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'ADDING…'; }

    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method:'POST',
      body: fd,
      headers: {'Accept':'application/json'}
    })
      .then(function(r){
        if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'error'); });
        return r.json();
      })
      .then(function(item){
        notify('"' + item.product_title + '" added — beautifully.');
        updateCartCount();
        if(btn){ btn.textContent = 'ADDED ✓'; setTimeout(function(){ btn.disabled = false; btn.textContent = orig; }, 1800); }
      })
      .catch(function(err){
        notify('error: ' + err.message);
        if(btn){ btn.disabled = false; btn.textContent = orig; }
      });
  });

  /* ──────── Cart line qty change ──────── */
  document.addEventListener('change', function(e){
    var input = e.target;
    if(!input.matches('.qty-input[data-line]')) return;
    var line = parseInt(input.dataset.line, 10);
    var qty = parseInt(input.value, 10) || 0;
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.reload(); });
  });

  /* ──────── Cart line remove ──────── */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.remove[data-line]');
    if(!btn) return;
    e.preventDefault();
    var line = parseInt(btn.dataset.line, 10);
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.reload(); });
  });

  /* init cart count on load */
  if(document.querySelector('[data-cart-count]')) updateCartCount();

})();
